import { Outlet, useNavigate } from "react-router-dom";
import FeedbackRoot from "galadrim-feedback";
import { ENV } from "../environment/environment";

export const FeedbackRootComponent = () => {
	const navigate = useNavigate();

	return (
		<>
			<Outlet />
			{ENV !== "production" && (
				<FeedbackRoot
					rootDir={import.meta.env.VITE_FRONTEND_ABSOLUTE_ROOT_DIR}
					projectId="5383d7b7-b601-4c95-a2cb-8a3a991906e1"
					navigate={(path) => navigate(path)}
					position="bottom-right"
					notionDatabaseId="1bc3c3f19e4381c3a210cef0ded54875"
				/>
			)}
		</>
	);
};
